var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade", appear: "" } }, [
    !_vm.isHidden
      ? _c("div", { staticClass: "form-group col-sm-4" }, [
          _c(
            "div",
            {
              staticClass: "items-container",
              class: [
                this.iconClass,
                { "enabled-container": _vm.showClickable },
                { "color-gray": !_vm.showClickable },
              ],
              on: { click: _vm.clickedOnButton },
            },
            [
              _c("div", { staticClass: "button-text-background" }, [
                _c("div", { staticClass: "button-text-container" }, [
                  _c("span", { staticClass: "button-text" }, [
                    _vm._v(_vm._s(_vm.$t(this.text))),
                  ]),
                ]),
              ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }